import { DAY_NAMES, DayName } from "../constants";

function formatTime(timeStr: string): string {
  let hours: number, minutes: string;
  
  // Handle "15:00:00" format
  if (timeStr.includes(":")) {
    const timeParts = timeStr.split(":");
    hours = parseInt(timeParts[0], 10);
    [, minutes] = timeParts;
  } else {
    // Handle "1500" format
    hours = parseInt(timeStr.slice(0, 2), 10);
    minutes = timeStr.slice(2);
  }
  
  const hour12 = hours % 12 || 12;
  const ampm = hours < 12 ? "AM" : "PM";
  return `${hour12}:${minutes} ${ampm}`;
}

function toMinutes(timeStr: string): number {
  let h: number, m: number;
  
  // Handle "15:00:00" format
  if (timeStr.includes(":")) {
    const timeParts = timeStr.split(":");
    h = parseInt(timeParts[0], 10);
    m = parseInt(timeParts[1], 10);
  } else {
    // Handle "1500" format
    h = parseInt(timeStr.slice(0, 2), 10);
    m = parseInt(timeStr.slice(2), 10);
  }
  
  return h * 60 + m;
}

const parseHoursOfOperation = (input: any) => {
  if (!input) return null;

  const dayMap = {
    Mon: "Monday",
    Tue: "Tuesday",
    Wed: "Wednesday",
    Thu: "Thursday",
    Fri: "Friday",
    Sat: "Saturday",
    Sun: "Sunday",
  };

  const now = new Date();
  const todayName = now.toLocaleDateString("en-US", { weekday: "long" }) as DayName;
  const currentMinutes = now.getHours() * 60 + now.getMinutes();
  const allDays = DAY_NAMES;

  const businessHours: any = {};

  // Initialize all days as closed
  allDays.forEach((day) => {
    businessHours[day] = { closed: true, openNow: false };
  });

  if (typeof input === "string") {
    input.split(";").forEach((entry: string) => {
      const match = entry.trim().match(/(\w{3}) (\d{4}) - (\d{4})/);
      if (match) {
        const [, dayAbbrev, openTime, closeTime] = match;
        const dayFull = dayMap[dayAbbrev as keyof typeof dayMap];

        const openMinutes = toMinutes(openTime);
        const closeMinutes = toMinutes(closeTime);

        const isToday = todayName === dayFull;
        const isOpenNow = 
          isToday && 
          currentMinutes >= openMinutes && 
          currentMinutes <= closeMinutes;

        businessHours[dayFull] = {
          open: formatTime(openTime),
          close: formatTime(closeTime),
          openNow: isOpenNow,
        };
      }
    });

    const todayIndex = allDays.indexOf(todayName);
    const sortedDays = [...allDays.slice(todayIndex), ...allDays.slice(0, todayIndex)];

    const orderedBusinessHours: any = {};
    sortedDays.forEach((day) => {
      orderedBusinessHours[day] = businessHours[day];
    });

    return orderedBusinessHours;
  } 

  // Initialize all days as closed first
  allDays.forEach((day) => {
    businessHours[day] = { closed: true, openNow: false };
  });

  // Process array data
  input.forEach((item: any) => {
    const day = allDays[item.day];
    const isToday = todayName === day;
    const openMinutes = toMinutes(item.open_time);
    const closeMinutes = toMinutes(item.close_time);

    const isOpenNow = isToday && currentMinutes >= openMinutes && currentMinutes <= closeMinutes;

    businessHours[day] = {
      open: formatTime(item.open_time),
      close: formatTime(item.close_time),
      openNow: isOpenNow,
    };
  });

  // Order days starting from today (same logic as string version)
  const todayIndex = allDays.indexOf(todayName);
  const sortedDays = [...allDays.slice(todayIndex), ...allDays.slice(0, todayIndex)];

  const orderedBusinessHours: any = {};
  sortedDays.forEach((day) => {
    orderedBusinessHours[day] = businessHours[day];
  });

  return orderedBusinessHours;
};

export default parseHoursOfOperation;
